import InfoBox from "../../components/InfoBox.jsx";
import {useTranslation} from "react-i18next";
import AuthImage from "../../mosaic/images/auth-image.jpg";
import AuthLayout from "../../layout/AuthLayout.jsx";
import {useRedirectAuthenticatedEffect} from "../../components/auth/useRedirectAuthenticatedEffect.js";

export default function SignUpGoToEmail() {
    useRedirectAuthenticatedEffect();

    let {t} = useTranslation();
    return <AuthLayout title={t('auth.sign-up')} authImage={AuthImage}>
        <InfoBox type="success">
            <div className="font-medium text-slate-800 dark:text-slate-100 mb-3">
                {t('auth.continue-registration-in-your-email-inbox')}
            </div>
            <div className="font-medium text-slate-800 dark:text-slate-100 mb-1">
                {t('auth.you-can-close-this-tab-or-window')}
            </div>
        </InfoBox>
    </AuthLayout>;
}
